import { createContext } from 'react';

import type { ModuleNode, FlattenedPermission } from '@/models/permission';

export interface PermissionContextType {
  modules: ModuleNode[];
  permissions: FlattenedPermission[];
  error: string | null;
  setModules: (modules: ModuleNode[]) => void;
  hasPermission: (code: string) => boolean;
  hasAnyPermission: (codes: string[]) => boolean;
  hasAllPermissions: (codes: string[]) => boolean;
  hasModule: (moduleName: string | number) => boolean;
  getModuleByName: (name: string) => ModuleNode | undefined;
  getModuleById: (id: number) => ModuleNode | undefined;
  getChildModules: (parentModuleName: string) => ModuleNode[];
}

export const PermissionContext = createContext<
  PermissionContextType | undefined
>(undefined);
